import React from "react";

const Container = ({ children }) => {
  return <div className="containerlg">{children}</div>;
};

export default Container;
